import { Checkbox } from "@mantine/core"
import React from "react"

const MantineCheckbox = (props: any) => {
    const { checked, classNames, label, onChange, wrapperProps, className, variant, color, labelPosition } = props
    return (
        <>
            <Checkbox
                classNames={classNames}
                className={className}
                label={label}
                checked={checked}
                onChange={onChange}
                wrapperProps={wrapperProps}
                variant={variant}
                color={color}
                labelPosition={labelPosition}
            />
        </>
    )
};
export default MantineCheckbox;
